import { render, staticRenderFns } from "./RenderChildrensRequestResponse.vue?vue&type=template&id=0cc7322f&"
import script from "./RenderChildrensRequestResponse.vue?vue&type=script&lang=js&"
export * from "./RenderChildrensRequestResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports